import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "carousel" }
const _hoisted_2 = ["src", "onClick"]

import { BannerItem, useNavigation } from '@/view/home/supportScript';
import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'carousalCard',
  props: {
    itemData: {}
  },
  setup(__props: any) {

const { goToPath } = useNavigation()
const props = __props

const filteredBannerList = computed(() => {
  const banners = props.itemData.banners
  if (Array.isArray(banners)) return banners.filter(item => item.display)
  const lang = localStorage.getItem('lang') || 'en'
  const list = (banners as Record<string, BannerItem[]>)[lang] || (banners as Record<string, BannerItem[]>)['en'] || []
  return list.filter(item => item.display)
})

return (_ctx: any,_cache: any) => {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_swipe, {
      autoplay: 3000,
      "lazy-render": "",
      loop: true,
      "show-indicators": false
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredBannerList.value, (item, index) => {
          return (_openBlock(), _createBlock(_component_van_swipe_item, { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: item?.url,
                alt: "",
                class: "carouselItem",
                onClick: ($event: any) => (_unref(goToPath)(item.redirectUrl))
              }, null, 8, _hoisted_2)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})